import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { ApiError, api, fetchApi } from '@/lib/api';
import { urlSanitize } from '@/lib/utils';
import ItemNotFound from './$name/-components/item-not-found';

export const Route = createFileRoute('/item/$uin/')({
  notFoundComponent: ItemNotFound,
  loader: async ({ params }) => {
    const { uin } = params;
    const uinNumber = Number(uin);

    if (Number.isNaN(uinNumber)) {
      throw notFound();
    }

    try {
      const result = await fetchApi(api.api.items({ uin }).name.get());
      const sanitizedName = urlSanitize(result.name);

      throw redirect({
        to: '/item/$uin/$name',
        params: {
          uin,
          name: sanitizedName,
        },
        throw: true,
      });
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) {
        throw notFound();
      }
      throw error;
    }
  },
});
